<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">固件包管理</div>

      <div class="search-wrapper">
         <el-form inline :model="queryForm">
            <el-form-item label="更新包类型">
               <el-select v-model="queryForm.deviceType" @change="clickQuery">
                  <el-option label="全部" value></el-option>
                  <el-option label="一体机安装包(1代)" value="一体机"></el-option>
                  <el-option label="一体机安装包(2代)" value="二代一体机"></el-option>
                  <el-option label="IPC" value="IPC"></el-option>
                  <el-option label="主控" value="主控"></el-option>
                  <el-option label="主屏幕固件包(1代)" value="主屏幕"></el-option>
                  <el-option label="主屏幕固件包(2代)" value="二代主屏幕"></el-option>
                  <el-option label="超脑" value="超脑"></el-option>
                  <el-option label="算力盒子" value="算力盒子"></el-option>
                  <el-option label="坐位体前屈软件安装包" value="坐位体前屈"></el-option>
                  <el-option label="坐位体前屈屏幕固件包" value="坐位体前屈固件包"></el-option>
                  <el-option label="LED大屏安装包" value="LED信息盒软件"></el-option>
                  <el-option label="智慧体育盒子安装包" value="高校体育盒子软件"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item>
               <el-button type="primary" @click="clickQuery">搜索</el-button>
               <el-button @click="clickReset">重置</el-button>
            </el-form-item>
         </el-form>
      </div>

      <div class="action-wrapper">
         <el-button class="right_f" type="primary" @click="clickAddition">新增</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="listData" border>
            <el-table-column align="center" label="序号" width="80" type="index"></el-table-column>
            <el-table-column align="center" label="类型" prop="deviceType"></el-table-column>
            <el-table-column align="center" label="版本号" prop="versionCode"></el-table-column>
            <el-table-column align="center" label="上传时间" min-width="120">
               <template #default="{ row }">
                  <div>{{ handleDate(row) }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="序列号" prop="versionSeq"></el-table-column>
            <el-table-column align="center" label="备注" prop="content"></el-table-column>
            <el-table-column align="center" label="操作" width="160">
               <template #default="{ row }">
                  <el-button type="text" size="small" @click="clickEdit(row)">编辑</el-button>
                  <el-button type="text" size="small" @click="clickDelete(row)">删除</el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination-wrapper">
         <el-pagination v-show="totalCount > 0" layout="prev, pager, next, jumper" :current-page="queryForm.pageNum"
            :page-size="queryForm.pageSize" :total="totalCount" @current-change="changeCurrentPage">
         </el-pagination>
      </div>

      <el-dialog :title="updateDialog.form.id ? '编辑版本' : '添加版本'" v-model="updateDialog.visible"
         :close-on-click-modal="false" :modal-append-to-body="false" destroy-on-close>
         <el-form ref="formRef" :model="updateDialog.form" :rules="rules" label-width="80px" v-loading="loading">
            <el-form-item label="平台" prop="deviceType">
               <el-radio-group v-model="updateDialog.form.deviceType" @change="changeDeviceType">
                  <el-radio label="一体机">一体机安装包(1代)</el-radio>
                  <el-radio label="二代一体机">一体机安装包(2代)</el-radio>
                  <el-radio label="IPC">IPC</el-radio>
                  <el-radio label="主控">主控</el-radio>
                  <el-radio label="主屏幕">主屏幕固件包(1代)</el-radio>
                  <el-radio label="二代主屏幕">主屏幕固件包(2代)</el-radio>
                  <el-radio label="超脑">超脑</el-radio>
                  <el-radio label="算力盒子">算力盒子</el-radio>
                  <el-radio label="坐位体前屈">坐位体前屈软件安装包</el-radio>
                  <el-radio label="坐位体前屈固件包">坐位体前屈屏幕固件包</el-radio>
                  <el-radio label="LED信息盒软件">LED大屏安装包</el-radio>
                  <el-radio label="高校体育盒子软件">智慧体育盒子安装包</el-radio>
                  <el-radio label="AI体锻小站软件">AI体锻小站安装包</el-radio>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="版本号" prop="versionCode">
               <el-input ref="codeRef" v-model="updateDialog.form.versionCode" placeholder="版本号格式为X.X.X" clearable />
            </el-form-item>
            <el-form-item label="应用包" class="android-update">
               <div class="flex width-100">
                  <el-upload ref="uploadRef" class="flex-sub flex" action="#########" :limit="1"
                     :accept="upload.fileAccept" :on-exceed="handleExceed" :http-request="uploadFile"
                     :file-list="upload.fileList">
                     <template #trigger>
                        <el-button style="margin-right: 8px" type="primary" :disabled="upload.disabled">文件上传</el-button>
                     </template>
                  </el-upload>
               </div>
            </el-form-item>
            <el-form-item label="序列号" prop="versionSeq">
               <el-input v-model="updateDialog.form.versionSeq" placeholder="序列号" clearable />
            </el-form-item>
            <el-form-item label="更新描述">
               <el-input v-model="updateDialog.form.content" :rows="4" type="textarea" placeholder="请输入内容"
                  :maxlength="200" show-word-limit />
            </el-form-item>
         </el-form>
         <template #footer>
            <div class="flex-row-center">
               <el-button @click="updateDialog.visible = false">取消</el-button>
               <el-button type="primary" @click="clickDone">确定</el-button>
            </div>
         </template>
      </el-dialog>

   </div>
</template>

<script>
import { OBSuploadApk } from '../../../../common/huaweicloud';

export default {
   data() {
      // 版本号校验
      const validVersionCode = (rule, value, callback) => {
         if (!value) {
            return callback(new Error('版本号不能为空'))
         }
         const reg = new RegExp(/^[1-9]\d{0,2}\.([1-9]\d{0,2}|0)\.([1-9]\d{0,2}|0)$/)
         if (reg.test(value)) {
            if (this.updateDialog.latest.includes(value)) {
               this.upload.disabled = true
               callback(new Error('版本号已存在'))
            } else {
               this.upload.disabled = false
               callback()
            }
         } else {
            this.upload.disabled = true
            callback(new Error('版本号格式不正确'))
         }
      }
      return {
         loading: false,
         queryForm: {
            deviceType: '',
            pageNum: 1,
            pageSize: 10,
         },
         listData: [],
         totalCount: 0,
         latestData: [],
         updateDialog: {
            visible: false,
            form: {},
            latest: [],
         },
         rules: {
            deviceType: [{ required: true, message: '请选择平台', trigger: 'blur' }],
            versionCode: [{ required: true, validator: validVersionCode, trigger: 'blur' }],
            versionSeq: [{ required: true, message: '请输入序列号', trigger: 'blur' }],
         },
         upload: {
            disabled: true,
            fileAccept: '.apk',
            fileList: [],
         },
         apkDevices: ['一体机', "二代一体机", '坐位体前屈', 'LED信息盒软件', '高校体育盒子软件', 'AI体锻小站软件'],
      }
   },

   mounted() {
      this.queryList();
   },

   methods: {
      // 查询固件分页列表
      queryList() {
         this.loading = true;
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/sys/appUpgrade/v210/page',
            params: this.queryForm,
         }).then((result) => {
            if (!result.body.data || JSON.stringify(result.body.data) === '{}') {
               this.totalCount = 0
               this.listData = []
               return
            }
            this.totalCount = result.body.data.total || 0;
            this.listData = result.body.data.content || [];
         }).catch(() => {
            this.totalCount = 0;
            this.listData = [];
         }).finally(() => {
            this.loading = false;
         })
      },

      // 查询最新固件包
      async queryLatest(type) {
         if (!this.latestData || this.latestData.length == 0) {
            try {
               let result = await this.$http({
                  method: 'get',
                  url: this.$util.aioIP + '/api/m/sys/appUpgrade/v210/getLatest',
               })
               if (!result.body.data || JSON.stringify(result.body.data) === '[]') {
                  this.latestData = []
                  return
               }
               this.latestData = result.body.data.map((item) => item.versionCode)
            } catch (error) {
               this.latestData = []
            }
         }
         if (type === 'add') {
            this.updateDialog.latest = this.latestData
         } else {
            this.updateDialog.latest = this.latestData.filter((item) => {
               return item.versionCode != updateDialog.form.versionCode
            })
         }
      },

      // 查询固件详情
      queryDetail(id) {
         this.updateDialog.form = {};
         this.loading = true;
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/sys/appUpgrade/detail',
            params: { id },
         }).then((result) => {
            if (result.body.data && JSON.stringify(result.body.data) !== '{}') {
               this.updateDialog.form = { ...result.body.data, versionSeq: result.body.data.versionSeq.toString() };
               this.queryLatest('edit');
               this.updateDialog.visible = true;
               this.upload.fileAccept = this.apkDevices.includes(this.updateDialog.form.deviceType) ? '.apk' : '.dav';
               this.upload.disabled = false;
            } else {
               this.$util.errorMsg('暂未获取到详情信息');
            }
         }).catch(() => {
            this.$util.errorMsg('获取到详情信息失败');
         }).finally(() => {
            this.loading = false;
         })
      },

      // 发送新增/编辑信息
      sendUpdate() {
         this.loading = true;
         let params = JSON.parse(JSON.stringify(this.updateDialog.form));
         params.type = 0;
         this.$http({
            method: 'post',
            url: this.$util.aioIP + '/api/m/sys/appUpgrade/v210/addOrUpdate',
            body: params,
         }).then((res) => {
            this.updateDialog.visible = false
            if (res.body.data === true) {
               this.$util.successMsg('添加成功')
               this.queryList();
            } else {
               this.$util.errorMsg(res.msg || '提交失败')
            }
         }).finally(() => {
            this.loading = false;
         })
      },

      // 删除固件请求
      queryDelete(id) {
         this.loading = true;
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/sys/appUpgrade/delete',
            params: { id },
         }).then((res) => {
            if (res.data.data === true) {
               this.$util.successMsg(res.data.msg);
               this.queryList();
            } else {
               this.$util.errorMsg(res.data.msg);
            }
         }).catch(() => {
            this.$util.errorMsg('删除失败，请稍后再试。')
         }).finally(() => {
            this.loading = false;
         })
      },

      // 上传文件
      async uploadFile(param) {
         const deviceType = this.updateDialog.form.deviceType;
         let fileName = param.file.name;
         const fileExt = fileName.substring(fileName.lastIndexOf('.'));
         if (this.apkDevices.includes(deviceType)) {
            if (fileExt !== '.apk') {
               this.$util.errorMsg('文件格式有误');
               return;
            }
         } else if (deviceType === '二代主屏幕') {
            if (fileExt !== '.zip') {
               this.$util.errorMsg('文件格式有误');
               return
            }
         } else if (fileExt !== '.dav') {
            this.$util.errorMsg('文件格式有误');
            return
         }
         let type = 'apk';
         if (deviceType === 'IPC') {
            type = 'ipc';
         } else if (deviceType === '主屏幕' || deviceType === '二代主屏幕') {
            type = 'screen';
         } else if (deviceType === '主控') {
            type = 'main';
         } else if (deviceType === '超脑') {
            type = 'brain';
         } else if (deviceType === '算力盒子') {
            type = 'box';
         } else if (deviceType === '坐位体前屈' || deviceType === '坐位体前屈固件包') {
            type = 'sit';
         } else if (deviceType === 'LED信息盒软件') {
            type = 'led';
         } else if (deviceType === '高校体育盒子软件') {
            type = 'box';
         } else if (deviceType === 'AI体锻小站软件') {
            type = 'station';
         } else {
            type = 'apk';
         }
         this.loading = true;
         OBSuploadApk(param.file, type, this.updateDialog.form.versionCode).then((res) => {
            if (res) {
               this.updateDialog.form.installAppUrl = res
            } else {
               this.$util.errorMsg('上传文件失败');
            }
            this.loading = false;
         })
      },

      // 点击新增
      clickAddition() {
         this.updateDialog.form = {
            deviceType: "一体机"
         };
         this.queryLatest('add');
         this.updateDialog.visible = true;
      },

      // 点击查询
      clickQuery() {
         this.queryList();
      },

      // 点击重置
      clickReset() {
         this.queryForm = {
            deviceType: '',
            pageNum: 1,
            pageSize: 10,
         };
         this.queryList();
      },

      // 点击编辑名称
      clickEdit(row) {
         this.queryDetail(row.id);
      },

      // 点击设备删除
      clickDelete(row) {
         this.$confirm('是否删除此设备?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.queryDelete(row.id);
         }).catch(() => { });
      },

      // 平台类型切换
      changeDeviceType(value) {
         if (this.apkDevices.includes(value)) {
            this.upload.fileAccept = '.apk';
         } else if (value === '二代主屏幕') {
            this.upload.fileAccept = '.zip';
         } else {
            this.upload.fileAccept = '.dav';
         }
      },

      // 点击确定
      clickDone() {
         this.$refs.formRef.validate((valid) => {
            if (valid) {
               this.sendUpdate();
            }
         })
      },

      // 切换页码
      changeCurrentPage(val) {
         this.queryForm.pageNum = val;
         this.queryList();
      },

      // 处理时间
      handleDate(row) {
         return this.$util.dateFormat(new Date(row.uploadTime))
      },

      // 替换上传文件 保证每次只能上传一个
      handleExceed(files) {
         this.$refs.uploadRef.clearFiles();
         const file = files[0];
         file.uid = genFileId();
         this.$refs.uploadRef.handleStart(file);
         this.$refs.uploadRef.submit();
      }
   }
}
</script>

<style scoped>
.el-radio-group {
   display: flex;
   flex-direction: row;
   align-items: center;
   gap: 16px;
}

.el-radio {
   margin-left: 0px;
   margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// FirmwareManage.vue?92e91e16